import _ from 'lodash'

/**
 * map filter hash ids to human readable data
 * @param {array} hashList list of filter id which needed to be mapped
 * @param {array} filterHashTable filter hash table
 */
export const mapFilterHash = (hashList, filterHashTable) => {
  const results = []

  filterHashTable.map(filterItem => {
    if (filterItem.groupData) {
      filterItem.groupData.map(groupItem => {
        if (hashList.includes(groupItem.filterId)) {
          results.push(groupItem)
        }
      })
    } else if (filterItem.filterId) {
      if (hashList.includes(filterItem.filterId)) {
        results.push(filterItem)
      }
    }
  })
  return results
}

/**
 * handle filter hash ids mapping result
 * @param {array} hashList list of filter id which needed to be mapped
 * @param {array} filterHashTable filter hash table
 */
export const fetchListByHash = (hashList, filterHashTable) => {
  let results = mapFilterHash(hashList, filterHashTable)

  if (!results || results.length === 0) {
    return null
  }
  return results
}

export const countConditions = (searchConditions) => {
  let count = 0

  // [2021-05-26] 隱藏體驗類型商品，故 searchType 不應計入篩選條件數
  // _.forEach(searchConditions.searchType, value => {
  //   if (value) {
  //     count++
  //   }
  // })
  _.forEach(searchConditions.filterIds, value => {
    if (value) {
      count++
    }
  })
  if (searchConditions.minPrice || searchConditions.maxPrice) {
    count++
  }
  return count
}

export const countConditionsFromQuery = (query) => {
  let count = 0

  // [2021-05-26] 隱藏體驗類型商品，故 searchType 不應計入篩選條件數
  // if (query.searchType === 'hotel' || query.searchType === 'experience') {
  //   count++
  // }
  if (query.filter) {
    if (Array.isArray(query.filter)) {
      count += query.filter.length
    } else if (typeof query.filter === 'string') {
      count++
    }
  }
  if (query.minPrice || query.maxPrice) {
    count++
  }
  return count
}

/**
 * append filter id to query
 * @param {object} query router query
 * @param {string} filterId filter id of searching list
 * @returns query object
 */
export const appendFilterToQuery = (query, filterId) => {
  const newQuery = _.cloneDeep(query)

  if (newQuery.filter) {
    if (!newQuery.filter.includes(filterId)) {
      newQuery.filter.push(filterId)
    }
  } else {
    newQuery.filter = [filterId]
  }
  return newQuery
}

/**
 * remove filter id from query
 * @param {object} query router query
 * @param {string} filterId filter id of searching list
 * @returns query object
 */
export const removeFilterFromQuery = (query, filterId) => {
  const newQuery = _.cloneDeep(query)

  if (newQuery['filter[]'] === filterId) {
    delete newQuery['filter[]']
  }
  if (newQuery.filter && newQuery.filter.length) {
    newQuery.filter = newQuery.filter.filter(f => f !== filterId)
  }
  return newQuery
}
